import React, {Component} from 'react'

export default function withHover(WrappedComponent) {

    class WithHover extends Component {

        constructor(props) {
            super(props);
            this.state = {hover: false};
        }

        _onMouseEnter = () => this.setState({hover: true})
        _onMouseLeave = () => this.setState({hover: false})

        render() {
            return <WrappedComponent {...this.props} {...this.state} onMouseEnter={this._onMouseEnter} onMouseLeave={this._onMouseLeave}/>
        }
    }

    return WithHover;
}



// WEBPACK FOOTER //
// ./src/hoc/withHover.js